import React from 'react';

const FlightHistory = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Flight History</h2>
      {/* Add flight history content here */}
    </div>
  );
};

export default FlightHistory; 